module.exports = __webpack_public_path__ + "static/media/new-logo.e9061428.png";